import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import DashSideBar from "../../shared/DashSideBar";
import "./OurImpact.css";
import { Editor } from "primereact/editor";

function OurImpacts() {
  let emptyOurImpact = {
    id: null,
    title: "",
    description: "",
    sortOrder: null,
  };
  const [OurImpacts, setOurImpacts] = useState(null);

  const [OurImpactsDialog, setOurImpactsDialog] = useState(false);
  const [DeleteOurImpact, setDeleteOurImpact] = useState(false);
  const [DeleteOurImpactsDialog, setDeleteOurImpactsDialog] = useState(false);
  const [OurImpact, setOurImpact] = useState(emptyOurImpact);
  const [selectedOurImpacts, setSelectedOurImpacts] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);

  const isFetched = useRef(false);

  useEffect(() => {
    if (!isFetched.current) {
      getOurImpacts();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);
  const getOurImpacts = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/OurImpacts"
      );

      if (response.data) {
        setOurImpacts(response.data);
      }
    } catch (error) {
      console.error("Error fetching OurImpacts:", error);
    }
  };

  const openNew = () => {
    setOurImpact(emptyOurImpact);
    setSubmitted(false);
    setOurImpactsDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setOurImpactsDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteOurImpact(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteOurImpactsDialog(false);
  };

  const saveService = async () => {
    setLoading(true);
    setSubmitted(true);

    try {
      if (OurImpact.title.trim()) {
        let _OurImpacts = [...OurImpacts];
        let _OurImpact = { ...OurImpact };

        if (OurImpact.id) {
          const index = findIndexById(OurImpact.id);

          let formData = new FormData();
          formData.append("id", OurImpact.id); // 👈 Make sure to include ID
          formData.append("title", _OurImpact.title);
          formData.append("description", _OurImpact.description);
          formData.append("sortOrder", _OurImpact.sortOrder);

          const response = await axios.put(
            process.env.REACT_APP_BACKEND_URL +
              "api/OurImpacts/" +
              OurImpact.id,
            formData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.data) {
            _OurImpacts[index] = _OurImpact;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Our Impact Content Updated",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Our Impact Content Not Updated",
              life: 3000,
            });
          }
        } else {
          _OurImpact.id = createId();
          let formData = new FormData();
          formData.append("title", _OurImpact.title);
          formData.append("description", _OurImpact.description);
          formData.append("sortOrder", _OurImpact.sortOrder);

          const response = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "api/OurImpacts",
            formData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.data) {
            _OurImpacts.push(response.data);
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Our Impact Content Added",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Our Impact Content Not Added",
              life: 3000,
            });
          }
        }

        setOurImpacts(_OurImpacts);
        setOurImpactsDialog(false);
        setOurImpact(emptyOurImpact);
      }
    } catch (error) {
      console.error("Error during save operation:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "An error occurred while saving the service. Please try again later.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const editProduct = (OurImpact) => {
    setOurImpact({ ...OurImpact });
    setOurImpactsDialog(true);
  };

  const confirmDeleteProduct = (OurImpact) => {
    setOurImpact(OurImpact);
    setDeleteOurImpact(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BACKEND_URL + "api/OurImpacts/" + OurImpact.id
      );

      setLoading(false);

      if (response.status === 204) {
        // ✅ Check response status instead of data
        let _OurImpacts = OurImpacts.filter((val) => val.id !== OurImpact.id);
        setOurImpacts(_OurImpacts);
        setDeleteOurImpact(false);
        setOurImpact(emptyOurImpact);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Our Impact Content Deleted",
          life: 3000,
        });
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Our Impact Content Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < OurImpacts.length; i++) {
      if (OurImpacts[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteOurImpactsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedOurImpacts.map((OurImpact) => OurImpact.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/OurImpacts/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _OurImpacts = OurImpacts.filter(
        (val) => !selectedOurImpacts.includes(val)
      );
      setOurImpacts(_OurImpacts);
      setDeleteOurImpactsDialog(false);
      setSelectedOurImpacts(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Our Impact Contents Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Our Impact Contents Not Deleted",
        life: 3000,
      });
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _OurImpact = { ...OurImpact };

    _OurImpact[`${name}`] = val;

    setOurImpact(_OurImpact);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Our Impact Content</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedOurImpacts || !selectedOurImpacts.length}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Project Icons</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        style={{ borderRadius: "10px" }}
        onClick={hideDialog}
      />
      <Button
        label="Save"
        loading={loading}
        style={{ borderRadius: "10px" }}
        icon="pi pi-check"
        onClick={saveService}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="OurImpact-container">
          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={OurImpacts}
              selection={selectedOurImpacts}
              onSelectionChange={(e) => setSelectedOurImpacts(e.value)}
              dataKey="id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Project Icons"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                field="title"
                header="Title"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>
              <Column
                field="sortOrder"
                header="Order"
                sortable
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={OurImpactsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="OurImpact Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            <div className="field">
              <label htmlFor="title" className="font-bold mb-1">
                Title :
              </label>
              <InputText
                id="title"
                value={OurImpact.title}
                onChange={(e) => onInputChange(e, "title")}
                required
                className={classNames({
                  "p-invalid": submitted && !OurImpact.title,
                })}
              />
              {submitted && !OurImpact.title && (
                <small className="p-error">Title is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="description" className="font-bold mb-1">
                Description :
              </label>
              <Editor
                id="description"
                value={OurImpact.description}
                style={{ height: "100px" }}
                onTextChange={(e) =>
                  onInputChange(
                    { target: { value: e.htmlValue } },
                    "description"
                  )
                }
                required
                className={classNames({
                  "p-invalid": submitted && !OurImpact.description,
                })}
              />
            </div>
            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={OurImpact.sortOrder}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !OurImpact.sortOrder,
                })}
              />
              {submitted && !OurImpact.sortOrder && (
                <small className="p-error">Sort Order is required.</small>
              )}
            </div>
          </Dialog>

          <Dialog
            visible={DeleteOurImpact}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {OurImpact && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{OurImpact.title}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={DeleteOurImpactsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {OurImpact && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected Impacts?
                </p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default OurImpacts;
